<template>
  <div class="popup-wrapper">
    <div class="popup-container center loading">
      <div class="popup">
        <div class="popup-content">
          <!-- <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" /> -->
          <IcLoading class="icn x2"/>
          <p class="txt mt12 mb0">Loading</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PCLoading',
  setup() {

  }
})
</script>
<style lang="scss" scoped>
  .popup-wrapper {
    z-index: 999;
  }
</style>
